import React from 'react';
import {
  mergeClasses
} from '@fluentui/react-components';
import {
  TilesGridCellImage,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useExampleImageStyles } from './style';

export const ExampleImage = (props) => {
  const {
    i18n,
    generateImageExample,
    classes,
  } = props;
  const baseClasses = useExampleImageStyles();

  return (
    <div className={mergeClasses('example-image-view', baseClasses, classes)}>
      <div className={mergeClasses('example-image')}>
        {generateImageExample && generateImageExample.imageUrl && <TilesGridCellImage
          src={generateImageExample.imageUrl}
          i18n={i18n}
          alt={i18n.getString(_TL_('Example image of a prompt'))}
        />}
      </div>
    </div >
  );
};
